// extracted by mini-css-extract-plugin
export default {"genresContainer":"Category_genresContainer__xXW2W"};